import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { DateService } from 'app/shared/date.service';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';
import { AppSettings } from 'app/shared/app-settings';
//import { IMyOptions } from 'mydatepicker';
import  '@progress/kendo-angular-intl/locales/he/all';
import { FormGroup , FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { stringify } from '@angular/core/src/util';
import { AdminService } from '../../admin.service';
import { numberSymbols } from '@telerik/kendo-intl';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadProgressTextService } from '../../admin-progress.service';
import { debug } from 'util';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { IOved } from 'app/admin/interface/ioved.interface';
import { UserMessagesService } from '../../../shared/user-messages/user-messages.service';
import { routerNgProbeToken } from '@angular/router/src/router_module';
declare var require: any;


@Component({
  selector: 'app-nofesh-admin-home',
  templateUrl: './nofesh-admin-home.component.html',
  styleUrls: ['./nofesh-admin-home.component.css']
})
export class NofeshAdminHomeComponent implements OnInit {
  moment = require("moment");



  ovedForm = this.fb.group({
    addUpdateOved:[0]
  })
  constructor(
    private fb:FormBuilder,
    private route:ActivatedRoute,
    private router:Router,
    private _adminService:AdminService,
    private loadProgressTextService: LoadProgressTextService,
    private userMessagesService: UserMessagesService
  ) { }

  ngOnInit() {
    // Component to delete
    
  }
  /*
  moveToReservationPage()
  {
    this.router.navigateByUrl("/admin")
  }
  
  back()
  {
    this.router.navigateByUrl("/admin");
    this.userMessagesService.clearAll();
  }
  */
}
